<template>
  <div class="menu-language">
    <div
      v-for="(lang, langIndex) in $ml.list"
      :key="lang"
      @click.prevent="langSwitch(lang)"
      class="lang-label"
      :class="$ml.current === lang ? 'selected' : ''"
    >
      <span>{{ lang }}</span
      ><span class="line">{{
        langIndex < $ml.list.length - 1 ? "|" : ""
      }}</span>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    langSwitch(val) {
      if (val !== this.$ml.current && this.$tvaMq === "desktop") {
        this.$router.push({ params: { lang: val } });
        this.$router.go();
      } else if (val !== this.$ml.current && this.$tvaMq !== "desktop") {
        this.$router.push({ params: { lang: val } });
        window.location.reload();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.menu-language {
  .mobile &,
  .tablet & {
    @include ButtonM;
    text-decoration: none;
    color: $white;
    display: flex;
    a {
      color: $white;
    }
  }
  .desktop & {
    @include ButtonS;
    a {
      color: $white-50;
    }
    display: flex;
    flex-direction: row;
    .lang-label {
      @include ButtonS;
      text-decoration: none;
      color: $white-50;
      cursor: pointer;
      a {
        color: $white-50;
      }
      &.selected {
        color: $white;
        font-weight: bold;
        pointer-events: none;
      }
    }
  }
  .lang-label {
    .line {
      font-weight: normal !important;
      margin: 0 6px;
    }
    &:hover {
      color: #fff;
    }
  }
}
</style>
